const __WEBPACK_NAMESPACE_OBJECT__ = require("live/components/time/ui/calendar/calendar-container");